import { Injectable } from '@angular/core';
import { ApiService } from '../api.service';
import { Observable } from 'rxjs';
import { HydraCollection } from '../hydra/hydra-collection';
import { UserModel } from '@core/api/models/user/user.model';
import { HttpHeaders } from '@angular/common/http';
import { environment } from '@env';


@Injectable({
  providedIn: 'root'
})
export class UserApiService extends ApiService {
  readonly resourcePath = 'users';

  list(filters: Record<string, string> = {}): Observable<HydraCollection<UserModel>> {
    return this.restList<UserModel>(filters);
  }

  get(id: string): Observable<any> {
    return this.restRead<any>(id);
  }

  update(id: string, data: object): Observable<UserModel> {
    return this.restUpdate<UserModel>(id, data);
  }

  create(data:object){
      return this.restCreate<UserModel>(data);
  }

  register(data:object){
      return this.http.post<any>(this.resourceUrl+'/register', data);
  }

  deactivate(token:string): Observable<UserModel> {

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/merge-patch+json'
      })
    };

    return this.http.patch(`${this.resourceUrl}/deactivate`, {token:token}, httpOptions) as Observable<UserModel>;
  }

  resetPassword(token:string, password: string): Observable<UserModel> {
    const data = {
      token: token,
      password: password
    };

    return this.http.patch(`${this.resourceUrl}/reset_password`, data) as Observable<UserModel>;
  }

  forgotpassword(data:object){
    return this.http.post(`${this.resourceUrl}/request_password_reset`, data);
  }

  addReferral(data:object){
    return this.http.post(`${this.apiUrl}/user_referrals`, data);
  }

  sendVerificationCode(){
    return this.http.post(`${this.resourceUrl}/enable_2fa`, {});
  }

  checkVerificationCode(code:string){
    const numCode = Number(code);
    
    return this.http.post(`${this.resourceUrl}/validate_2fa`, {authCode: numCode});
  }

  disableMfa(){
    return this.http.post(`${this.resourceUrl}/disable_2fa`, {});
  }

  requestNewVerificationCode(){
    return this.http.post(`${environment.meWrapperApiUrl}/auth/users/resend_2fa`, {}, {
      observe: 'response',
      withCredentials: true,
    });
  }

  invalidateTrustedDevices(){
    return this.http.post(`${this.resourceUrl}/invalidate_trusted_devices`, {});
  }

  getPrivacy(){
    return this.http.get(`${this.resourceUrl}/privacy`);
  }
}
